<template>
  <v-container fluid id="MyTruckRequests" class="pa-0 pa-sm-3">
    <v-row wrap>
      <v-col cols="12" xs="12" class="headline pb-0">
        My Truck Requests
        <v-btn color="primary" small class="ml-4" to="/truck-requests/new"
          ><v-icon small left>add</v-icon> New</v-btn
        >
      </v-col>
      <v-col cols="12" xs="12" class="">
        <v-card>
          <v-tabs>
            <v-tab @click="truckRequestType('open')"
              >Open<span class="caption ml-1 grey--text"></span
            ></v-tab>
            <v-tab @click="truckRequestType('scheduled')">Scheduled</v-tab>
            <v-tab @click="truckRequestType('closed')">Closed</v-tab>
            <v-tab @click="truckRequestType('cancelled')">Cancelled</v-tab>
          </v-tabs>
          <v-divider></v-divider>
          <v-data-table
            :items="currentTruckRequests"
            :loading="loadingTruckRequests"
            loading-text="Loading....please wait."
            :headers="headers"
            disable-sort
          >
            <template v-slot:item.orderNumber="{ item }">
              <span class="subtitle-2">#{{ item.orderNumber }}</span>
            </template>
            <template v-slot:item.requestDate="{ item }">
              {{ item.requestDate | moment("MMM Do, YYYY")
              }}<span v-if="item.requestTime"> at {{ item.requestTime }}</span>
              <div
                v-if="item.scheduledDay"
                class="caption green--text text--darken-3"
              >
                {{ item.scheduledDay.displayDate }}<br />
                {{ item.scheduledTime }}<br />
              </div>
            </template>
            <template v-slot:item.address="{ item }">
              {{ item.jobSite.street }}
              <span class="caption">({{ item.jobSite.jobId }})</span>
            </template>
            <template v-slot:item.requestType="{ item }">
              <truck-request-details :showNotes="false" :order="item" />
            </template>
            <template v-slot:item.orderedBy="{ item }">
              {{ item.orderedBy.firstName }}
              {{ item.orderedBy.lastName }}
              <div class="grey--text caption">
                on
                {{ item.orderDate.toDate() | moment("MMM Do [at] h:mma") }}
              </div>
            </template>
            <template v-slot:item.status="{ item }">
              <status-chip :status="item.status" />
            </template>
            <template v-slot:item.details="{ item }">
              <v-btn
                color="primary"
                small
                outlined
                text
                @click.stop="showTicket(item)"
                >Details</v-btn
              >
              <v-menu
                bottom
                left
                v-if="!['cancelled', 'closed'].includes(item.status)"
              >
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item
                    v-for="o in requestOptions"
                    :key="o.title"
                    @click="requestOption(o, item)"
                  >
                    <v-list-item-title>{{ o.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="dialog" width="500" persistent>
      <truck-request-ticket
        :truckRequest="currentTicket"
        @close="closeTicket"
        :showClose="true"
      />
    </v-dialog>
  </v-container>
</template>
<script>
import fb from "@/main";
import { mapState } from "vuex";
import truckRequestTicket from "@/components/truckRequests/truckRequestTicket";
import truckRequestDetails from "@/components/truckRequests/truckRequestDetails";
import statusChip from "@/components/StatusChip";
export default {
  components: {
    truckRequestTicket,
    truckRequestDetails,
    statusChip,
  },
  data() {
    return {
      requestOptions: [{ title: "Cancel Request" }],
      type: "open",
      dialog: false,
      loadingTruckRequests: true,
      workOrders: [],
      currentTicket: null,
      snack: false,
      snackColor: "",
      snackText: "",
      headers: [
        {
          text: "Order",
          align: "left",
          value: "orderNumber",
          sortable: false,
          width: 60,
        },
        { text: "Request Date", value: "requestDate", width: 180 },
        { text: "Job", value: "address" },
        { text: "Details", value: "requestType" },
        // { text: "Ordered By", value: "orderedBy" },
        { text: "Status", value: "status", align: "left" },
        { text: "", value: "details", align: "right" },
      ],
    };
  },
  computed: {
    currentTruckRequests: function() {
      return this.workOrders.filter((wo) => wo.status == this.type);
    },
    ...mapState(["user"]),
  },
  async created() {
    this.getTruckRequests();
  },
  methods: {
    async getTruckRequests() {
      try {
        const workOrders = await fb.db
          .collection("truckRequests")
          .where("orderedBy.uid", "==", this.user.uid)
          .orderBy("orderDate", "desc")
          .limit(50)
          .get();
        this.workOrders = [];
        workOrders.forEach((u) => {
          this.workOrders.push({
            id: u.id,
            ...u.data(),
          });
        });
        this.loadingTruckRequests = false;
      } catch (error) {
        alert(error);
        console.log(error);
        this.loadingTruckRequests = false;
      }
    },
    truckRequestType(type) {
      this.type = type;
    },
    closeTicket() {
      this.dialog = false;
    },
    showTicket(ticket) {
      this.currentTicket = null;
      this.currentTicket = { ...ticket };
      this.dialog = true;
    },
    async requestOption(option, truckRequest) {
      try {
        await fb.db
          .collection("truckRequests")
          .doc(truckRequest.id)
          .update({
            status: "cancelled",
            cancelledBy: this.user,
          });
        const truckRequestEmails = await fb.functions.httpsCallable(
          "truckRequestEmails"
        );
        truckRequestEmails({
          order: truckRequest,
          emailType: "Cancelled",
        });
        this.getTruckRequests();
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Successfully cancelled request";
      } catch (error) {
        this.snack = true;
        this.snackColor = "Error";
        this.snackText = "Error cancelling request";
      }
    },
  },
};
</script>
